
export type UserProfileUpdateRequestPreferencesTheme = typeof UserProfileUpdateRequestPreferencesTheme[keyof typeof UserProfileUpdateRequestPreferencesTheme];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserProfileUpdateRequestPreferencesTheme = {
  light: 'light',
  dark: 'dark',
  auto: 'auto',
} as const;
